(() => {
  let announcement;
  let observer;
  const update = () => {
    if (!announcement?.isConnected) return;
    document.body.style.setProperty('--sega-announcement-height', announcement.getBoundingClientRect().height + 'px');
  };
  const initialize = () => {
    observer?.disconnect();
    announcement = document.querySelector('.announcement-bar-section');
    document.body.classList.toggle('segastore-service-ready', Boolean(announcement));
    if (!announcement) {
      document.body.style.removeProperty('--sega-announcement-height');
      return;
    }
    update();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(announcement);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  window.addEventListener('resize', update, {passive: true});
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
})();
